import { MultiTierTax } from './../../classes/multiTierTax/multiTierTax';
import { rates } from './config';
import { InkomstenBelastingConfig } from './interface';

export class InkomstenBelasting {
    
    tax: number;
    
    constructor(data: InkomstenBelastingConfig) {
        const property = data.senior ? 'senior' : 'nonSenior';
        this.tax = new MultiTierTax(rates[property][data.year], data.income).tax;
    }
    
}
